import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import { OrderIssuesContainer, OrderIssuesHeading, OrderIssuesText, StyledButton } from './styled';

export const NeedHelpLarge = ({ children }: { children: React.ReactNode }) => {
  const { formatMessage } = useIntl();

  return (
    <OrderIssuesContainer>
      <Box>
        <OrderIssuesHeading>{formatMessage({ id: 'needHelp' })}</OrderIssuesHeading>
        <OrderIssuesText>
          {formatMessage({ id: 'issuesDuringExperience' })}&nbsp;
          {formatMessage({ id: 'visitSupport' }).toLowerCase()}
        </OrderIssuesText>
      </Box>
      <Box>
        <StyledButton to={routes.support}>{formatMessage({ id: 'visitSupport' })}</StyledButton>
      </Box>
      {children}
    </OrderIssuesContainer>
  );
};
